export const useSxStyles = () => {
  return {
    fieldComponent: {
      paddingTop: '4px',
    },
    inputTableItem: {
      alignItems: 'center',
      clear: 'left',
    },
    inputTableItem1: {
      clear: 'left',
    },
    fieldLabel: {
      display: 'block',
      fontWeight: 'bold',
      padding: '2px',
      fontSize: '13px',
      marginTop: '5px',
    },
    fieldInput: {
      width: '350px',
      padding: '3px 6px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '14px',
      '&.error': {
        borderColor: '#d43f3a',
      },
    },
    errorMsgText: {
      width: '280px',
      float: 'left',
      padding: '3px 6px',
      color: '#d43f3a',
      fontSize: '14px',
    },
    checkbox: {
      padding: '3px 6px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '14px',
    },
    option: {
      display: 'inline-block',
      fontSize: '14px',
    },
    required: {
      width: '6px',
      height: '6px',
      background: '#d9534f',
      display: 'inline-block',
      margin: '4px 4px 0 4px',
      borderRadius: '3px',
    },
    highlightLabel: {
      color: '#05A4D8',
    },
  };
};
